export const VIPSDataServiceURL = process.env.REACT_APP_VIPS_Data_Service_URL;
export const URL = process.env.REACT_APP_VIPS_Data_Service_URL;
export const OCC_URL = process.env.REACT_APP_OCC_URL;
export const OCC_ORDER_SUBMIT_URL = process.env.REACT_APP_OCC_ORDER_SUBMIT_URL;

export const requestOptions = {
  method: "POST",
  headers: {
    // Authorization: "Basic RW1pbHk6QXZlcnlAMTIzNDU=",
    //Authorization: "Basic YmFkaHJpLmluZm9zeXM6QmFkaHJpQDEyMzQ=",
    Authorization: "Basic T0VGb3JtVXNlcjpBdmVyeUAxMjM0NQ==",
    ReactApiKey: process.env.REACT_APP_API_KEY
  },
};

export const RedirectUrl = process.env.REACT_APP_SITE_URL + `/logon.aspx`;

export const ORDERING_PATH =process.env.REACT_APP_ORDERING_PATH
export const MenuURL = process.env.REACT_APP_SITE_URL;

export const AppURL= process.env.REACT_APP_SITE;

export const HomePage = `http://rbis.averydennison.com/en/home.html`;

export const PrivacyNotes = `http://www.averydennison.com/en/home/legal-privacy-notices.html`;

export const TermsAndCondition = `http://rbis.averydennison.com/en/home/terms-and-conditions.html`;

export const ContactUs = `http://rbis.averydennison.com/en/home/about-us/contact-us.html`;

export const RequiredField = "Required Field";

export const Table = "Table";

export const Quantity = "Quantity";

export const LabPrefix = "LAB";

export const ExtendedLinkedList = "Extended Linked List";

export const LinkedChildList = "Linked Child List";

export const FibreList = "Fibre List";

export const CatalogueTable = "Catalogue Table";

export const OCCHomePage = process.env.REACT_APP_OCC_URL;
